import { FC } from 'react';

export type DiskListIconProps = {};

export const DiskListIcon: FC<DiskListIconProps> = ({}) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 8.00004L6 8.00004M14 4.00004L6 4.00004M14 12L6 12M3.33333 8.00004C3.33333 8.36823 3.03486 8.66671 2.66667 8.66671C2.29848 8.66671 2 8.36823 2 8.00004C2 7.63185 2.29848 7.33337 2.66667 7.33337C3.03486 7.33337 3.33333 7.63185 3.33333 8.00004ZM3.33333 4.00004C3.33333 4.36823 3.03486 4.66671 2.66667 4.66671C2.29848 4.66671 2 4.36823 2 4.00004C2 3.63185 2.29848 3.33337 2.66667 3.33337C3.03486 3.33337 3.33333 3.63185 3.33333 4.00004ZM3.33333 12C3.33333 12.3682 3.03486 12.6667 2.66667 12.6667C2.29848 12.6667 2 12.3682 2 12C2 11.6319 2.29848 11.3334 2.66667 11.3334C3.03486 11.3334 3.33333 11.6319 3.33333 12Z"
      stroke="#475467"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
